/**
 * Pixi needs a WebGL (or WebGPU) context. Probe a throwaway canvas — never the
 * game canvas — so Application.init can still create the real context.
 * jsdom tests and some locked-down iframes stay on Canvas 2D.
 */

export function canUsePixi(opts) {
  opts = opts || {};
  if (opts.force === false) return false;
  if (opts.force === true) return true;
  if (typeof document === "undefined") return false;
  try {
    var probe = document.createElement("canvas");
    probe.width = 2;
    probe.height = 2;
    var gl2 = probe.getContext("webgl2");
    if (gl2) return true;
    var gl = probe.getContext("webgl") || probe.getContext("experimental-webgl");
    return !!gl;
  } catch (e) {
    return false;
  }
}
